// Копирайт юридически значимых мест: строка акцепта под кнопкой регистрации и шторка для тех,
// кто зарегистрировался раньше, чем появились документы. Секции в spec/08_copy.md нет — оферта
// пришла позже копи-документа (docs/legal.md §13.3).
//
// ГОЛОС ЛУНИ ЗДЕСЬ ПРИГЛУШЁН, и это то же правило, что на экране приватности и в разборах
// (CLAUDE.md §19 и §21): человек читает строку, которой заключает договор. Мем в ней означал бы,
// что мы сами не считаем её настоящей. Тон остаётся тёплым и на «ты», ирония выключена.
//
// ПОЧЕМУ СТРОКА РАЗБИТА НА КУСКИ. Слова «условия» и «политика» — ссылки внутри предложения,
// а не строки-кнопки под ним. Сборка идёт в `TermsAcceptNote`; собирать её конкатенацией в
// разметке нельзя (правило 16 — хардкода строк там не бывает).
//
// ФОРМУЛИРОВКА ПРО ПОЛИТИКУ — ОТДЕЛЬНЫМ ПРЕДЛОЖЕНИЕМ, И ЭТО ГЛАВНОЕ ЗДЕСЬ. С 01.09.2025
// (ФЗ № 156-ФЗ) согласие на обработку персональных данных обязано быть отдельным документом:
// «нажимая кнопку, вы принимаете оферту И даёте согласие на обработку» делает согласие
// неполученным (docs/legal.md §4.3). Поэтому кнопкой принимаются ТОЛЬКО условия, а политика
// названа тем, чем является, — документом, который рассказывает, что происходит с данными.
// Обработка у нас построена на договоре, а не на согласии; ни слова «согласие» в этой строке
// быть не должно ни сейчас, ни после любой правки текста.
import type { LegalCopy } from './types'

export const legal: LegalCopy = {
  accept: {
    before: 'Нажимая кнопку, ты принимаешь ',
    terms: 'условия',
    between: ' и ',
    policy: 'политику',
    after: '.',
  },
  resume: {
    title: 'Теперь у меня есть условия',
    // Три вещи, которые обязан узнать человек, уже пользующийся приложением: документ новый,
    // а не «вы что-то пропустили»; данные не изменились; бесплатное осталось бесплатным.
    body: 'Раньше документов не было, теперь есть. В условиях — что я умею, чего не обещаю и как со мной расстаться. Что происходит с твоими данными — там же, где и было, в политике. Приложение остаётся бесплатным.',
    cta: 'Принимаю условия',
  },
  terms_doc: 'Пользовательское соглашение',
  policy_doc: 'Политика обработки персональных данных',
}
